import request from '../utils/request';

export default {
  // 获取基础配置
  deviceGetConfig: query => {
    return request({
      url: 'device/plat/config/getConfig',
      method: 'get',
      params: query,
    });
  },
  // 保存基础配置
  deviceSaveConfig: query => {
    return request({
      url: 'device/plat/config/save',
      method: 'post',
      data: query,
    });
  },
  // 电量预警
  deviceMonitorWarnBattery: query => {
    return request({
      url: 'device/plat/monitor/warnBattery',
      method: 'get',
      params: query,
    });
  },
  // 信号预警
  deviceMonitorWarnRssi: query => {
    return request({
      url: 'device/plat/monitor/warnRssi',
      method: 'get',
      params: query,
    });
  },
  // 设备列表
  deviceDeviceList: query => {
    return request({
      url: 'device/plat/device/list',
      method: 'get',
      params: query,
    });
  },
  // 强制解绑设备
  deviceForceUnbind: query => {
    return request({
      url: 'device/plat/device/forceUnbind',
      method: 'post',
      data: query,
    });
  },
  // 解绑设备
  deviceUnbind: query => {
    return request({
      url: 'device/plat/device/unbind',
      method: 'post',
      data: query,
    });
  },
  // 设备重启
  deviceReboot: query => {
    return request({
      url: 'device/plat/device/reboot',
      method: 'post',
      data: query,
    });
  },
  // 设备-用户列表
  deviceUserList: query => {
    return request({
      url: 'device/plat/device/deviceUserList',
      method: 'post',
      data: query,
    });
  },
  // 设备-日志
  deviceLog: query => {
    return request({
      url: 'device/plat/device/log',
      method: 'get',
      params: query,
    });
  },
  // 删除设备
  deviceDel: query => {
    return request({
      url: 'device/plat/device/del',
      method: 'post',
      data: query,
    });
  },
  // 设备详情
  deviceDeviceDetail: query => {
    return request({
      url: 'device/plat/device/detail',
      method: 'get',
      params: query,
    });
  },
  // 首页统计
  deviceStatisIndex: query => {
    return request({
      url: 'device/plat/statis/index',
      method: 'get',
      params: query,
    });
  },
  // 按家庭统计
  deviceStatisFamily: query => {
    return request({
      url: 'device/plat/statis/family',
      method: 'get',
      params: query,
    });
  },
  // 开门记录
  deviceDeviceOpen: query => {
    return request({
      url: 'device/plat/device/open',
      method: 'get',
      params: query,
    });
  },
};
